(function () {
  var FORM_ID = 'TUSkdH';
  var SESSION_KEY = 'cart_exit_popup_shown';
  var FREE_SHIP_THRESHOLD_CENTS = 60 * 100;
  var PRODUCTS_LIMIT = 50;
  var SCROLL_DOWN_PCT = 0.4;
  var SCROLL_UP_SPEED = 1.5;

  var path = window.location.pathname.toLowerCase();

  if (path !== '/cart' && path !== '/cart/') return;
  if (sessionStorage.getItem(SESSION_KEY)) return;

  var triggered = false;
  var cartSnapshot = null;

  function formatMoney(cents, currency) {
    var amount = (cents / 100).toFixed(2);
    try {
      return new Intl.NumberFormat(undefined, { style: 'currency', currency: currency || 'USD' }).format(amount);
    } catch (e) {
      return '$' + amount;
    }
  }

  function escapeHtml(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function openPopup() {
    if (triggered) return;
    if (sessionStorage.getItem(SESSION_KEY)) return;

    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (!cart || cart.item_count === 0) return;
        cartSnapshot = cart;
        triggered = true;
        sessionStorage.setItem(SESSION_KEY, '1');
        window._klOnsite = window._klOnsite || [];
        window._klOnsite.push(['openForm', FORM_ID]);
      })
      .catch(function () { /* silent */ });
  }

  var isMobile = window.innerWidth < 768 || /Mobi|Android/i.test(navigator.userAgent);

  if (!isMobile) {
    document.addEventListener('mouseout', function (e) {
      if (e.relatedTarget || e.toElement) return;
      if (e.clientY > 10) return;
      openPopup();
    });
  } else {
    var maxPct = 0;
    var lastY = window.scrollY;
    var lastT = Date.now();
    var passedThreshold = false;

    window.addEventListener('scroll', function () {
      var y = window.scrollY;
      var docH = document.documentElement.scrollHeight - window.innerHeight;
      var pct = docH > 0 ? y / docH : 0;
      if (pct > maxPct) maxPct = pct;
      if (maxPct >= SCROLL_DOWN_PCT) passedThreshold = true;

      var now = Date.now();
      var dy = y - lastY;
      var dt = now - lastT;

      if (passedThreshold && dy < 0 && dt > 0) {
        var speed = Math.abs(dy) / dt;
        if (speed > SCROLL_UP_SPEED) openPopup();
      }
      lastY = y;
      lastT = now;
    }, { passive: true });
  }

  var formProcessed = false;

  function findPlaceholderNode(marker) {
    var walker = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT, null, false);
    var n;
    while ((n = walker.nextNode())) {
      if (n.nodeValue.indexOf(marker) !== -1) return n;
    }
    return null;
  }

  function isBundle(p) {
    var tagsStr = typeof p.tags === 'string' ? p.tags : (p.tags || []).join(',');
    var tags = tagsStr.toLowerCase().split(',').map(function (t) { return t.trim(); });
    if (tags.indexOf('bundle') !== -1) return true;
    if ((p.product_type || '').toLowerCase() === 'bundle') return true;
    return false;
  }

  function fetchRecommendedProducts(cart) {
    return fetch('/products.json?limit=' + PRODUCTS_LIMIT)
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var cartProductIds = {};
        (cart.items || []).forEach(function (i) { cartProductIds[i.product_id] = true; });
        return (data.products || []).filter(function (p) {
          if (isBundle(p)) return false;
          if (cartProductIds[p.id]) return false;
          return true;
        });
      })
      .catch(function () { return []; });
  }

  function renderProductsHTML(products) {
    if (!products.length) return '<div></div>';
    var html = '<div style="overflow-x:auto;margin:12px -16px;padding:0 16px 8px;-webkit-overflow-scrolling:touch;">';
    html += '<div style="display:flex;gap:12px;flex-wrap:nowrap;min-width:min-content;">';
    products.forEach(function (p) {
      var img = '';
      if (p.images && p.images[0] && p.images[0].src) {
        img = p.images[0].src.split('?')[0] + '?width=180';
      } else if (p.featured_image) {
        img = (typeof p.featured_image === 'string' ? p.featured_image : p.featured_image.src || '').split('?')[0] + '?width=180';
      }
      var title = p.title || '';
      var url = '/products/' + (p.handle || '');
      var price = '';
      if (p.variants && p.variants[0] && p.variants[0].price) {
        var priceNum = parseFloat(p.variants[0].price);
        if (!isNaN(priceNum)) price = formatMoney(Math.round(priceNum * 100));
      }
      html += '<a href="' + escapeHtml(url) + '" style="flex:0 0 auto;display:flex;flex-direction:column;align-items:center;width:100px;text-decoration:none;color:inherit;">';
      html += '<img src="' + escapeHtml(img) + '" style="width:100px;height:100px;object-fit:cover;border-radius:6px;display:block;" alt="' + escapeHtml(title) + '" loading="lazy">';
      html += '<div style="font-size:11px;margin-top:6px;text-align:center;line-height:1.25;max-width:100px;">' + escapeHtml(title) + '</div>';
      if (price) {
        html += '<div style="font-size:11px;margin-top:2px;font-weight:600;">' + price + '</div>';
      }
      html += '</a>';
    });
    html += '</div></div>';
    return html;
  }

  function freeShippingMessage(cart) {
    if (!cart || cart.item_count === 0) return 'Subscribe & Save 20% — try it now';
    var diff = FREE_SHIP_THRESHOLD_CENTS - cart.total_price;
    if (diff <= 0) return 'Free shipping unlocked';
    return "You're only " + formatMoney(diff, cart.currency) + ' away from free shipping';
  }

  function processFormWhenReady() {
    if (formProcessed) return;
    var cartNode = findPlaceholderNode('CART_PRODUCTS');
    var shipNode = findPlaceholderNode('FREE_SHIPPING_MSG');
    if (!cartNode && !shipNode) return;

    formProcessed = true;
    console.log('[cart-exit] processing form');

    var run = function () {
      if (shipNode && shipNode.parentNode) {
        shipNode.nodeValue = shipNode.nodeValue.replace('FREE_SHIPPING_MSG', freeShippingMessage(cartSnapshot));
      }
      if (cartNode && cartNode.parentNode) {
        fetchRecommendedProducts(cartSnapshot || { items: [] }).then(function (products) {
          if (!cartNode.parentNode) return;
          var wrapper = document.createElement('div');
          wrapper.innerHTML = renderProductsHTML(products);
          if (wrapper.firstChild) {
            cartNode.parentNode.insertBefore(wrapper.firstChild, cartNode);
          }
          cartNode.nodeValue = cartNode.nodeValue.replace('CART_PRODUCTS', '');
        });
      }
    };

    if (!cartSnapshot) {
      fetch('/cart.js')
        .then(function (r) { return r.json(); })
        .then(function (cart) { cartSnapshot = cart; run(); })
        .catch(run);
    } else {
      run();
    }
  }

  setInterval(processFormWhenReady, 300);
  var mo = new MutationObserver(processFormWhenReady);
  mo.observe(document.body, { childList: true, subtree: true });
})();
